import {WebFormModel} from "capitalist-shared/src/core/model";
import axios from "axios";
import moment from "moment";

interface KycDataInterface extends Record<string, any> {
  status: OndatoKycStatuses
  kyc: any
}

export enum OndatoKycStatuses {
  APPROVED = "normalKyc",
  REJECTED = "rejected",
  PENDING = "pending",
  NOKYC = "nokyc"
}

export class WalletoResetKycModel extends WebFormModel {

  kycData: KycDataInterface | null = null

  rememberCancelForAwhile() {
    localStorage.setItem('rememberResetKycLater', moment().add(60, 'minute').valueOf() + '' as string);
  }

  checkCancel() {
    const t: number = +localStorage.getItem('rememberResetKycLater') || 0;
    if (t && t > 0) {
      const r = t < moment().valueOf();
      if (r) {
        localStorage.removeItem('rememberResetKycLater');
      }
      return !r;
    } else
      return false;
  }

  checkWalletoProfile() {
    return axios.post('/webapi/cards/checkKyc', {call: 'status'}).then((response) => {
      this.kycData = response.data.kycData;
      return this.kycData;
    });
  }

  makeFreeKyc() {
    //return Promise.reject('https://capitalist.net/');
    return axios.post('/webapi/cards/makeFreeKyc', {}).then((response) => {
      if (response.data.redirect)
        return response.data.redirect;
      else throw new Error('No redirect url found.');
    });
  }

  get hasKycData(): boolean {
    return Boolean(this.kycData);
  }

  get isRejected(): boolean {
    return this.hasKycData && (this.kycData.status == OndatoKycStatuses.REJECTED);
  }

  get isShowModal(): boolean {
    return this.hasKycData &&
      [OndatoKycStatuses.REJECTED].indexOf(this.kycData.status) >= 0;
  }
}
